import { I18n } from '@affine/i18n';
import type { NotificationService } from '@blocksuite/affine/shared/services';

import { AIProvider } from '../provider';

/**
 * Asks before a chat is deleted for good. Resolves to whether it is gone, so
 * the caller can leave the chat if it was the open one.
 */
export async function confirmAndDeleteChat(
  notificationService: NotificationService,
  session: Pick<BlockSuitePresets.AIRecentSession, 'workspaceId' | 'sessionId'>
): Promise<boolean> {
  if (!AIProvider.histories) return false;
  const confirmed = await notificationService.confirm({
    title: I18n.t('com.streamlain.ai.chat.history.delete-confirm.title'),
    message: I18n.t('com.streamlain.ai.chat.history.delete-confirm.message'),
    confirmText: I18n.t('com.streamlain.ai.chat.history.delete'),
    cancelText: I18n.t('com.streamlain.confirmModal.button.cancel'),
  });
  if (!confirmed) return false;
  // Chats belong to the workspace, not to a document.
  await AIProvider.histories.cleanup(session.workspaceId, undefined, [
    session.sessionId,
  ]);
  return true;
}
